module.exports = __webpack_public_path__ + "static/media/logo-riivi-purple.dbfb6ee0.svg";